import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import Button from 'components/button/button';
import Link from 'components/link';
import { AppUI } from '@seedlang/state';

const Wrapper = styled.div`
  height: 240px;
  overflow: scroll;
  margin: 0 0 10px 0;
  h3 {
    font-size: 16px;
  }
  p {
    font-size: 13px;
    line-height: 14px;
  }
`;

@observer
class DailyActivityInfo extends React.Component {

  render() {
    return (
      <Wrapper>
        <h3>What is XP?</h3>
        <p>XP stands for "experience points", and is given for performing learning activities across Seedlang.</p>
        <h3>What is a Streak?</h3>
        <p>A "streak" is the number of consecutive days in which you meet your XP requirements.</p>
        <h3>What if I lose my streak?</h3>
        <p>You can extend your streak by an extra day by reaching {AppUI.user.streakExtendGoal}XP in one day.</p>
        <p>This can be enabled or disabled on the <Link to='settings.user_profile' className='underline' target='_blank'>settings page.</Link></p>
        <p>If you are a Pro member, you can also repair your streak once a month by clicking this button.</p>
        <Link to='settings.streak_repair'>
          <Button
            padding='10px'
            borderRadius='5px'
            fontSize='13px'
          >
            Repair Streak
          </Button>
        </Link>
        <h3>Can I update my time zone?</h3>
        <p>Yes, you can do this by going to your settings page.</p>
        <Link to='settings.user_profile'>
          <Button
            padding='10px'
            borderRadius='5px'
            fontSize='13px'
          >
            Settings Page
          </Button>
        </Link>
      </Wrapper>
    );
  }
}

export default DailyActivityInfo;
